import {Ng1Controller, Transition, TargetState, StateService} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {AuthorizeNetTransactionDto} from "../../model/AuthorizeNetTransactionDto";
import {QbCustomerDto} from "../../model/QbCustomerDto";

export default class TransactionsWithoutPaymentProfileController implements Ng1Controller {
    private error: any;
    private transactions: AuthorizeNetTransactionDto[] = [];
    private syncing: boolean;

    $onInit(): void {
        this.refresh();
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }

    constructor(private $dataHub: DataHubService, private $state: StateService, private $stateParams: any) {
        $dataHub.onConnected(this.refresh);

        $dataHub.client.bindAllAuthorizeNetTransaction(() => this.transactions);
    }

    refresh = () => {
        if (!this.$dataHub.isConnected) return;
        this.$dataHub.server.paymentTransactionsWithoutProfile();
    };

    save = (txn: any, customer: QbCustomerDto) => {
        txn.working = true;
        this.$dataHub.server.paymentTransactionCreateProfile(txn, customer)
            .then(() => this.transactions.remove(txn, x => x.guid))
            .catch(e => {
                console.error(e);
                alert(e);
            })
            .finally(() => {
                txn.working = false;
            });
    }

    sync = () => {
        this.syncing = true;
        this.$dataHub.server.paymentTransactionSync()
            .finally(() => this.syncing = false);
    }
}
